import { SWITCH_LANGUAGE } from '../actions/types';

export default function reducerLangSwitch(state = 0, action) {

  switch(action.type) {
    case SWITCH_LANGUAGE:
        return action.payload;
    default:
        return state;
  }
}
